import axios from '@/bootstrap'
const endpoint = 'location-components'

export default class LocationComponentsService {
  list(params) {
    return axios.get(`/api/${endpoint}`, params).then(res => res.data)
  }

  program(programId) {
    return axios.get(`/api/${endpoint}/program/${programId}`).then(res => res.data)
  }
}
